import { render } from "./ToPDFRender.vue?vue&type=template&id=258f4071&scoped=true"
import script from "./ToPDFRender.vue?vue&type=script&lang=ts"
export * from "./ToPDFRender.vue?vue&type=script&lang=ts"

import "./ToPDFRender.vue?vue&type=style&index=0&id=258f4071&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-258f4071"

export default script